import {
  BG_STYLES,
  BORDER_STYLES,
  Button,
  BUTTON_TYPE,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import { ResponsiveContext } from "app/context/ResponsiveUIContext";
import { ROUTES } from "app/farmer360/routes/types";
import { rnNavigation } from "app/utils/appConfig";
import React, { useContext } from "react";
import { View, Text } from "react-native";
import CreditHeroCard from "./CreditHeroCard";
import { CreditResponse, FarmerCreditResponse } from "../../models/credit";

interface Props {
  creditDetails: CreditResponse | null;
  farmerId: string;
  farmerName?: string;
  farmerCreditDetails: FarmerCreditResponse | null;
}

const CreditLimitCard = ({
  creditDetails,
  farmerId,
  farmerName,
  farmerCreditDetails,
}: Props) => {
  const { mediaStyles } = useContext(ResponsiveContext);
  const formatAmount = (value?: number) =>
    value === null || value === undefined
      ? "-"
      : `₹ ${value.toLocaleString("en-IN")}`;

  const {
    available_credit_limit: availableLimit,
    total_outstanding_amount: outstanding,
    credit_limit: sanctionedLimit,
  } = creditDetails?.credit_lines?.[0] || {};

  const { pending_emi: pendingEmi, due_date: dueDate } =
    farmerCreditDetails || {};

  return (
    <View
      style={[
        BG_STYLES.bgWhite,
        COMMON_STYLES.br1,
        COMMON_STYLES.p1,
        BORDER_STYLES.borderNeutral80,
        COMMON_STYLES.fullWidth,
        mediaStyles({
          desktopStyle: {
            flexDirection: "row",
            alignItems: "flex-start",
          },
        }),
      ]}
    >
      <View style={[styles.heroWrap]}>
        <CreditHeroCard
          farmerName={farmerName}
          pendingEmi={pendingEmi ?? 0}
          dueDate={dueDate ?? ""}
        />
      </View>
      {/* RIGHT SECTION */}
      <View
        style={[
          styles.detailsWrap,
          COMMON_STYLES.p1,
          COMMON_STYLES.justifyBetween,
        ]}
      >
        <View style={[styles.metricRow]}>
          <Text
            style={[
              styles.metricLabel,
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            Sanctioned Credit Limit:
          </Text>

          <View style={[styles.metricValueGroup]}>
            <Text
              style={[
                styles.metricValue,
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              {formatAmount(sanctionedLimit)}
            </Text>
            {/* <Text
              style={[
                TYPOGRAPHY.CAPTION1,
                VARIANTS_STYLES.BASE,
                TEXT_STYLES.textNeutral80,
              ]}
            >
              (Interest Rate: {interestRate})
            </Text> */}
          </View>
        </View>

        {/* outstanding */}
        <View style={[styles.metricRow, COMMON_STYLES.mt1]}>
          <Text
            style={[
              styles.metricLabel,
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            Total Outstanding:
          </Text>

          <Text
            style={[
              styles.metricValue,
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral100,
            ]}
          >
            {formatAmount(outstanding)}
          </Text>
        </View>

        {/* available */}
        <View style={[styles.metricRow, COMMON_STYLES.mt1]}>
          <Text
            style={[
              styles.metricLabel,
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            Available Credit Limit:
          </Text>

          <Text
            style={[
              styles.metricValue,
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral100,
            ]}
          >
            {formatAmount(availableLimit)}
          </Text>
        </View>

        <Button
          text={"View Details"}
          onClick={() => {
            rnNavigation({
              name: ROUTES.FARMER_CREDIT_DETAILS,
              params: { farmerId, name: farmerName ?? "" },
            });
          }}
          type={BUTTON_TYPE.SECONDARY}
          buttonStyle={[COMMON_STYLES.mt2, styles.viewDetailsBtn]}
        />
      </View>
    </View>
  );
};

const styles = {
  heroWrap: {
    flex: 1.2,
    minWidth: 360,
  },
  detailsWrap: {
    flex: 1,
    minWidth: 320,
    maxWidth: 430,
  },
  metricRow: {
    flexDirection: "row" as const,
    justifyContent: "space-between" as const,
    alignItems: "flex-start" as const,
    gap: 16,
  },
  metricLabel: {
    flex: 0.55,
    lineHeight: 38,
  },
  metricValueGroup: {
    flex: 0.45,
    alignItems: "flex-end" as const,
  },
  metricValue: {
    flex: 0.45,
    textAlign: "right" as const,
    lineHeight: 38,
  },
  viewDetailsBtn: {
    alignSelf: "stretch" as const,
    width: "100%" as const,
  },
};

export default CreditLimitCard;
